import { render, staticRenderFns } from "./COM_Footer.vue?vue&type=template&id=672bdcc9&scoped=true&"
import script from "./COM_Footer.vue?vue&type=script&lang=js&"
export * from "./COM_Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672bdcc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672bdcc9')) {
      api.createRecord('672bdcc9', component.options)
    } else {
      api.reload('672bdcc9', component.options)
    }
    module.hot.accept("./COM_Footer.vue?vue&type=template&id=672bdcc9&scoped=true&", function () {
      api.rerender('672bdcc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/ubossOnePage/COM_Footer.vue"
export default component.exports